import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { BaseApiService } from '../../../shared/base-service/base-api.service';
import { MvdnowClaimAccountDenialRequestModel } from '../shared/models/mvdnow-claim-account-denial-request.model';

@Injectable({
    providedIn: 'root'
})
export class MvdNowClaimAccountModalService extends BaseApiService {
    constructor() {
        super();
    }

    canShowPrompt(customerNumberId: number): Observable<boolean> {
        return this.get(`customer/mvdnow/claimaccount/${customerNumberId}/showprompt`).pipe(map((response) => response.result));
    }

    getClaimAccountDenialReasons(): Observable<any> {
        return this.get('customer/mvdnow/claimaccount/denialreasontypes').pipe(map((response) => response.result));
    }

    public submitClaimAccountDenial(request: MvdnowClaimAccountDenialRequestModel): Observable<any> {
        return this.post('customer/mvdnow/claimaccount/denial', request);
    }
}
